export enum View {
  TABLE = 'TABLE',
  GRID = 'GRID'
}

export enum ModalMode {
  CREATE_USER = 'CREATE_USER',
  EDIT_PASSWORD = 'EDIT_PASSWORD',
  EDIT_USER = 'EDIT_USER',
}

export interface UsersState {
  users: User[];
  isDataLoading: boolean;
  view: View;
  modal: {
    open: boolean;
    mode: ModalMode;
    form: {
      selectedUuid: string | null;
      fields: AddUserForm;
    };
  };
  table: {
    columns: string[];
  };
  serverErrors: ServerError[];
  statusOptions: string[];
}

export interface UserCoreForm {
  firstName: string;
  lastName: string;
  position: string;
  email: string;
  status: string;
  login: string;
  activeApplications?: string[];
}

export interface User extends UserCoreForm {
  description: string;
  multiHotel: boolean;
  uuid: string;
}

export interface AddUserForm extends UserCoreForm {
  password: string;
  repeatPassword: string;
}

export type EditUserForm = Omit<AddUserForm, 'login' | 'password' | 'repeatPassword'>;

export type EditPasswordForm = Pick<AddUserForm, 'password' | 'repeatPassword'>;

export interface GetUsersResponse {
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  content: User[];
}

export type PostUserRequest = Omit<AddUserForm, 'repeatPassword'>

export type EditUserRequest = EditUserForm & Pick<User, 'uuid'>

export interface ServerError {
  field: keyof PostUserRequest;
  reason: string;
}

export interface ChangePasswordPayload {
  uuid: string;
  password: string;
}
